import { DEFAULT_PAGINATION } from "@/constants";
import { useState } from "react";
import { Filter, OnSearchFilterSortPaginate, Pagination, Search, Sort } from "../Table";

export default function useTableStateParams({
  defaultPagination,
  defaultSort,
  defaultFilter,
  defaultSearch,
}: {
  defaultPagination?: Pagination;
  defaultSort?: Sort;
  defaultFilter?: Filter;
  defaultSearch?: Search;
}) {
  const [filter, setFilter] = useState<Filter>(defaultFilter || {});
  const [sort, setSort] = useState<Sort>(defaultSort || null);
  const [search, setSearch] = useState<Search>(defaultSearch || {});
  const [pagination, setPagination] = useState<Pagination>(defaultPagination || DEFAULT_PAGINATION);

  const clear = () => {
    setFilter({});
    setSort(null);
    setSearch({});
    setPagination(defaultPagination || DEFAULT_PAGINATION);
  };

  const onSearchFilterSortPaginate: OnSearchFilterSortPaginate = ({
    pagination,
    search,
    filter,
    sort,
  }) => {
    if (filter) {
      setFilter(filter);
    }
    if (sort !== undefined) {
      setSort(sort);
    }
    if (pagination) {
      setPagination(pagination);
    }
    if (search) {
      setSearch(search);
    }
  };

  return {
    filter,
    sort,
    search,
    pagination,
    setPagination,
    setSort,
    onSearchFilterSortPaginate,
    clear,
  };
}
